












import {Vue, Component} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import ToolbarMixin from '@/mixins/ToolbarMixin.vue';
import {Call, Sync} from 'vuex-pathify';
import CancelBookingProcessMixin from '@/mixins/CancelBookingProcessMixin.vue';

@Component({
    components: {},
})
export default class BookingNavbar extends Mixins(UserRoleMixin, ToolbarMixin, CancelBookingProcessMixin) {

}
